import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h18v8zM6 15h2v-2h2v-2H8V9H6v2H4v2h2z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "14.5",
  cy: "13.5",
  r: "1.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "18.5",
  cy: "10.5",
  r: "1.5"
})), 'VideogameAssetOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VideogameAssetOutlined.js
// module id = 7061
// module chunks = 2